import React, { useEffect, useState } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { logout } from "utils/helper";
import { Link, useHistory } from "react-router-dom";
import { getAllNotification } from "service/Notification";
import Profile from "component/Profile/index";
import { Toast } from "utils/toast";
import { io } from "socket.io-client";
import logo from "assets/images/logo.png";
import { history } from "helpers";
import styles from "./Header.module.scss";
import Notification from "component/NotifyComp";
import Popup from "component/common/Popup/Popup";
import NotifyComp from "component/NotifyComp";

const Header = ({ toggle }) => {
  let [isOpen, setIsOpen] = useState(false);

  let [user, setUser] = useState(null);

  let [count, setCount] = useState(0);

  const [open, setOpen] = useState(false)
  // const history = useHistory()

  useEffect(() => {
    try {
      setUser(JSON.parse(localStorage.getItem("user")));
      console.log(JSON.parse(localStorage.getItem("user")), 'notify');
      getNotification();
    }
    catch (error) {
      alert(error)
    }

    // const socketNotify = io("http://doodlebluelive.com:2369");
    // // const socketNotify = io("https://api.mrmed.in", {
    // //   path: "/notification/socket.io",
    // //   transports: ["websocket"],
    // // });
    // socketNotify.on("connection", (id) => {
    //   console.log(id);
    //   socketNotify.emit("adminUsers", {
    //     // permission: userInfo.userType === 1 ? [] : userInfo.permission,
    //   });
    // });
  }, []);

  const getNotification = async () => {
    try {
      let response = await getAllNotification();
      if (response.status == 200) {
        setCount(response.data.data.pageMeta.total);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  const toggleProfile = () => {
    setIsOpen(!isOpen);
  };

  const openNotification = () => {
    setOpen(true)
  }

  const handleCancel = () => {
    setOpen(false)
    getNotification()
  }
  if (user == null) return null;

  return (
    <>
      <div className={styles.header}>
        <div className={styles.logo}>
          <i className="icon-hamburger" onClick={() => toggle()}></i>
          <img src={logo} alt="" />
        </div>
        <div className={styles.profile}>
          <div className={styles.notify} onClick={openNotification}>
            <i className="bi bi-bell-fill"></i>
            {count != 0 && (
              <div className={styles.notify_badge}>
                <span>{count}</span>
              </div>
            )}
          </div>
          <Popup isOpen={open} setPopup={() => handleCancel()} >
            <NotifyComp closePopUp={() => handleCancel()} />
          </Popup>
          <div className={styles.avatar}>
            <span>{String(user.name).charAt(0).toUpperCase()}</span>
          </div>
          <UncontrolledDropdown>
            <DropdownToggle tag="span" data-toggle="dropdown">
              <div className={styles.profile_options}>
                <span>{user.name}</span>
                <i className="icon-drop-down"></i>
              </div>
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => toggleProfile()}>
                <div className={styles.profile_item}>
                  <i className="icon-user"></i>
                  <span>My Profile</span>
                </div>
              </DropdownItem>
              <DropdownItem onClick={() => logout()}>
                <div className={styles.profile_item}>
                  <i className="icon-sign-out"></i>
                  <span>Logout</span>
                </div>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      </div>
      <Profile isOpen={isOpen} toggle={toggleProfile} />
    </>
  );
};

export default Header;
